import { ComponentGalleryProps } from './ComponentManager.types'
import { ComponentManagerComponentRow } from './ComponentManager.styles'
import { Gallery } from '../gallery/Gallery'
import { Element as ScrollElement } from 'react-scroll'
import Column from '../grid/column/Column'
import React from 'react'
import SectionTitle from '../section-title/SectionTitle'

const ComponentGallery = ({ component: { images, title, hash, showInList }, ...props }: ComponentGalleryProps) => {
    return (
        images.length && (
            <ScrollElement name={hash}>
                <ComponentManagerComponentRow {...props}>
                    <Column cols={12}>
                        <SectionTitle>{title}</SectionTitle>
                    </Column>
                    <Column cols={12}>
                        <Gallery images={images} pagination={showInList} />
                    </Column>
                </ComponentManagerComponentRow>
            </ScrollElement>
        )
    )
}

export default ComponentGallery
